import { createContext } from 'react';

import { AnnotationsTooltipConfig } from '../../core/components/annotations/components/tooltip/types/annotations-tooltip-props.js';
import { XYChartAnnotationsMarkerProps } from '../slots/Annotations/Marker.js';
import { XYChartAnnotationsTrackProps } from '../slots/Annotations/Track.js';
import { XYChartData } from '../types/xy-chart.js';

/**
 * Configuration for XY chart annotations.
 * @public
 */
export interface XYChartAnnotationsConfigProps {
  /** The ID of the X axis to which the annotations are attached. */
  xAxisId: string;
  /** Whether to show annotation labels. */
  showLabels: boolean;
  /** Number of fixed annotation tracks to display. */
  fixedTracks: number;
  /** The data used for the annotations. */
  data: XYChartData[];
  /** Configuration for annotation tracks. */
  tracksConfig: XYChartAnnotationsTrackProps;
  /** Configuration for annotation markers. */
  markersConfig: XYChartAnnotationsMarkerProps;
  /** Configuration for the annotations tooltip. */
  tooltip: AnnotationsTooltipConfig;
}

export const XYChartAnnotationsConfig = createContext<
  XYChartAnnotationsConfigProps | undefined
>(undefined);
